




































































































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';

const namespace: string = 'auth';

@Component
export default class ModalRegister extends Vue {
  @Prop({ type: Boolean, default: false }) isModalRegister!: boolean;

  @Action('emailCheck', { namespace }) c_emailCheck!: any;
  @Action('register', { namespace }) c_register!: any;
  @Action('login', { namespace }) c_login!: any;

  @Getter('getterIsEmail', { namespace }) c_getterIsEmail!: boolean;
  @Getter('getterIsRegister', { namespace }) c_getterIsRegister!: any;

  public dialogVisible: boolean = this.isModalRegister;
  public isDisabled: boolean = false;
  public alreadyAccount: any = '';
  public isIdCheck: boolean = false;
  public checkAll: boolean = false;
  public isIndeterminate: boolean = false;
  public ruleForm: any = {
    email: '',
    password: '',
    fullName: '',
    policy: [],
  };

  get isId() {
    const callback = (...arg: any) => {
      let e = arg.length > 0 && arg[0] !== undefined ? arg[0] : [];
      let errors = e;
      if (!Array.isArray(errors)) errors = [errors];
    };
    let type: string = 'info';
    this.isEmail(this.rules.email, this.ruleForm.email, callback)
      ? (type = 'primary')
      : (type = 'info');

    return type;
  }

  get isNotEmpty() {
    let type: string = 'info';
    if (
      this.ruleForm.fullName !== '' ||
      this.ruleForm.email !== '' ||
      this.ruleForm.password !== '' ||
      this.ruleForm.policy.indexOf('pec1') > -1
    )
      type = 'primary';
    return type;
  }

  public isEmail = (rule: any, value: any, callback: any) => {
    const reg: any = /([\w]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/gi;
    if (!reg.test(value)) {
      callback(new Error('이메일 형식이 아닙니다.'));
      return false;
    } else {
      return true;
    }
  };

  public isPolicy = (rule: any, value: any, callback: any) => {
    if (value.includes('pec1') && value.includes('pec2') && value.includes('pec3')) {
      callback();
    } else {
      callback(new Error('필수 동의 항목입니다.'));
    }
  };

  public rules = {
    email: [
      { required: true, message: '필수 입력 항목입니다.', trigger: 'blur' },
      { type: 'email', trigger: ['blur', 'change'], message: '이메일 형식이 아닙니다.' },
    ],
    password: [
      { type: 'string', required: true, message: '필수 입력 항목입니다.', trigger: 'blur' },
      { min: 6, max: 30, message: '6자 이상 입력해주세요', trigger: 'blur' },
    ],
    fullName: [
      { type: 'string', required: true, message: '필수 입력 항목입니다.', trigger: 'blur' },
      { min: 2, max: 15, message: '2자 이상 입력해주세요.', trigger: 'blur' },
    ],
    policy: [
      {
        type: 'array',
        required: true,
        message: '필수 동의 항목입니다.',
        trigger: 'change',
      },
      { validator: this.isPolicy, trigger: 'blur' },
    ],
  };

  handleCheckAllChange(val: any) {
    this.ruleForm.policy = val ? ['pec1', 'pec2', 'pec3', 'pec4'] : [];
    this.isIndeterminate = false;
  }

  created() {
    if (this.c_getterIsRegister.email !== undefined) {
      this.ruleForm.email = this.c_getterIsRegister.email;
      this.isDisabled = true;
    }
  }

  @Emit('emitModalRegisterClose')
  handleClose() {
    this.dialogVisible = false;
  }

  /**
   * @summary check id
   * @description  Boolean value by API call
   */
  async checkId() {
    try {
      this.isIdCheck = true;
      await this.c_emailCheck({
        email: this.ruleForm.email,
      });
      this.isIdCheck = false;

      if (this.c_getterIsEmail) this.alreadyAccount = '이미 가입된 이메일입니다.';
      else {
        this.alreadyAccount = '';
        this.$message.success('사용할 수 있는 이메일입니다.');
      }
    } catch (e) {
      this.isIdCheck = false;
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  submitForm(formName: string) {
    (this.$refs[formName] as any).validate(async (valid: boolean) => {
      if (valid) {
        try {
          let cloneRuleForm: any = JSON.stringify(this.ruleForm);
          cloneRuleForm = JSON.parse(cloneRuleForm);
          cloneRuleForm.policy = undefined;
          await this.c_register({
            payload: cloneRuleForm,
            inviteMember: this.c_getterIsRegister,
          });
          await this.c_login({
            email: this.ruleForm.email,
            password: this.ruleForm.password,
          });
          this.dialogVisible = false;
          // this.$message.success('회원가입을 완료하였습니다.');
        } catch (e) {
          console.log(e);
          this.$message.error(e.response.data.error.message);
        }
      } else {
        this.$message.error('유효하지 않은 형식의 데이터가 있습니다.');
        return false;
      }
    });
  }
}
